const visibleCardsGroupIdsReducer = (cardsGroupIds = [], action) => {
    switch(action.type){
        case 'CHANGE_VISIBLE_CARDS_GROUP_IDS':
            return action.data;
        default:
            return cardsGroupIds;
    }
}

export default visibleCardsGroupIdsReducer;